/*
 *
 * session.js
 *
 */

import { createSlice } from "@reduxjs/toolkit";
import sessionAPI from "../../api/sessionAPI";
import thunk from "../../helpers/thunk";

/* thunks */
const login = thunk("session/login", sessionAPI.login, (o) => o.r.data.token);

const sendPasswordReset = thunk(
  "session/sendPasswordReset",
  sessionAPI.sendPasswordReset,
  (o) => o.r.data
);

const resetPassword = thunk(
  "session/resetPassword",
  sessionAPI.resetPassword,
  (o) => o.r.data
);

/* slice */
const slice = createSlice({
  name: "session",
  initialState: {
    isAuth: false,
    userID: null,
  },
  reducers: {
    initSession: (state, action) => {},
    logout: (state, action) => {
      state.isAuth = false;
      state.userID = null;
    },
  },
  extraReducers: {
    [login.pending]: (state, action) => {},
    [login.fulfilled]: (state, action) => {
      state.isAuth = true;
      state.userID = action.payload.userID;
    },
    [login.rejected]: (state, action) => {
      state.isAuth = false;
      state.userID = null;
    },
  },
});

export { login, sendPasswordReset, resetPassword };
export const { initSession, logout } = slice.actions;
export default slice.reducer;
